import $ from 'jquery';
import 'readmore-js';

$(function () {
    $('.rw-description__content').readmore({
        embedCSS: true,
        moreLink: '<a href="#" class="btn btn--primary mt-4"><div class="btn__arrow"><i class="fas fa-plus"></i></div>Lees meer</a>',
        lessLink: '<a href="#" class="btn btn--primary mt-4"><div class="btn__arrow"><i class="fas fa-minus"></i></div>Toon minder</a>',
        collapsedHeight: 303,
    });
    $('.rw-description__kenmerken').readmore({
        embedCSS: true,
        moreLink: '<a href="#" class="btn btn--primary mt-4"><div class="btn__arrow"><i class="fas fa-plus"></i></div>Meer kenmerken</a>',
        lessLink: '<a href="#" class="btn btn--primary mt-4"><div class="btn__arrow"><i class="fas fa-minus"></i></div>Toon minder</a>',
        collapsedHeight: 303,
    });
    if (screen.width < 767) {
        $('.archive-search').readmore({
            embedCSS: true,
            moreLink: '<a href="#" class="btn btn--secondary mt-3"><div class="btn__arrow"><i class="fas fa-plus"></i></div>Meer filters</a>',
            lessLink: '<a href="#" class="btn btn--secondary mt-3"><div class="btn__arrow"><i class="fas fa-minus"></i></div>Minder filters</a>',
            collapsedHeight: 135,
        });
    }
});

